$(function() {

	$('.search-engine .input_cont-f').on('click touchstart', function(e) {
		e.preventDefault();
		$(this).addClass('active');
		$(this).children('.hidden_area').addClass('active');
	});

	// $('.search-engine .custom-select').on('click touchstart', function() {
	// 	$(this).addClass('active');
	// 	$(this).children('.hidden_area').addClass('active');

	// });

	$(document).mouseup(function(e) { // событие клика по веб-документу
		var div = $(".hidden_area"); // тут указываем ID элемента
		var div2 = $(".input_cont-f"); // тут указываем ID элемента
		if (!div.is(e.target) // если клик был не по нашему блоку
			&&
			div.has(e.target).length === 0) { // и не по его дочерним элементам
			div.removeClass('active'); // скрываем его
			div2.removeClass('active'); // скрываем его
		}
		if (!div2.is(e.target) // если клик был не по нашему блоку
			&&
			div2.has(e.target).length === 0) { // и не по его дочерним элементам
			div2.removeClass('active'); // скрываем его
		}
	});

	///

	var x, i, j, l, ll, selElmnt, a, b, c;
	/* Look for any elements with the class "custom-select": */
	x = document.getElementsByClassName("custom-select");
	l = x.length;
	for (i = 0; i < l; i++) {
		selElmnt = x[i].getElementsByTagName("select")[0];
		ll = selElmnt.length;
		/* For each element, create a new DIV that will act as the selected item: */
		a = document.createElement("DIV");
		a.setAttribute("class", "select-selected");
		a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
		x[i].appendChild(a);
		/* For each element, create a new DIV that will contain the option list: */
		b = document.createElement("DIV");
		b.setAttribute("class", "select-items select-hide");
		for (j = 1; j < ll; j++) {
			/* For each option in the original select element,
			create a new DIV that will act as an option item: */
			c = document.createElement("DIV");
			c.innerHTML = selElmnt.options[j].innerHTML;
			c.addEventListener("click", function(e) {
				/* When an item is clicked, update the original select box,
				and the selected item: */
				var y, i, k, s, h, sl, yl;
				s = this.parentNode.parentNode.getElementsByTagName("select")[0];
				sl = s.length;
				h = this.parentNode.previousSibling;
				for (i = 0; i < sl; i++) {
					if (s.options[i].innerHTML == this.innerHTML) {
						s.selectedIndex = i;
						h.innerHTML = this.innerHTML;
						y = this.parentNode.getElementsByClassName("same-as-selected");
						yl = y.length;
						for (k = 0; k < yl; k++) {
							y[k].removeAttribute("class");
						}
						this.setAttribute("class", "same-as-selected");
						break;
					}
				}
				h.click();
			});
			b.appendChild(c);
		}
		x[i].appendChild(b);
		a.addEventListener("click", function(e) {
			/* When the select box is clicked, close any other select boxes,
			and open/close the current select box: */
			e.stopPropagation();
			closeAllSelect(this);
			this.nextSibling.classList.toggle("select-hide");
			this.classList.toggle("select-arrow-active");
		});
	}

	function closeAllSelect(elmnt) {
		/* A function that will close all select boxes in the document,
		except the current select box: */
		var x, y, i, xl, yl, arrNo = [];
		x = document.getElementsByClassName("select-items");
		y = document.getElementsByClassName("select-selected");
		xl = x.length;
		yl = y.length;
		for (i = 0; i < yl; i++) {
			if (elmnt == y[i]) {
				arrNo.push(i)
			} else {
				y[i].classList.remove("select-arrow-active");
			}
		}
		for (i = 0; i < xl; i++) {
			if (arrNo.indexOf(i)) {
				x[i].classList.add("select-hide");
			}
		}
	}

	/* If the user clicks anywhere outside the select box,
	then close all select boxes: */
	document.addEventListener("click", closeAllSelect);

});

$(function() {

	$('.wrap-catalog-items-filtering__title').on('click', function(e) {
		e.preventDefault();
		$(this).toggleClass('active');
		$(this).next('ul').slideToggle(400);
	});

	$('[data-toggle="tooltip"]').tooltip();

	$('.text-toggle').collapser({
		mode: 'chars',
		truncate: 250,
		ellipsis: '...',
		showText: '',
		hideText: '',
		controlBtn: 'collapser_btn'
	});

	$('.btn-reset').click(function() {
		$("#filterForm input[type='checkbox']").prop('checked', false);
		$('.list-group-label__input').trigger('change');
	});

	$('.wrap-catalog-items-filtering__mobile-btn-open-filtering').on('click', function() {
		$('#filterForm').slideToggle();
	});

	$('.wrap-catalog-items-content__btn-more').on('click', function() {
		$(this).closest('.wrap-catalog-items-content__description').find('.collapser_btn').trigger('click');
	});

	var slider = $('#slider').slider({
		handle: 'square',
		tooltip: 'always',
		tooltip_split: 'true',
		tooltip_position: 'bottom',
		reversed: true
	});

	var updateCartDebounce = debounce(function() {
		$("#filterForm").submit();
	}, 1000);

	// $("body").on("change", ".list-group-label__input", function() {
	// 	var em = $(this);
	// 	if (em.data("type") == "single") {
	// 		$("input[name='" + em.attr("name") + "']").each(function() {
	// 			if ($(this).attr("value") != em.attr("value")) {
	// 				$(this).prop('checked', false);
	// 			}
	// 		});
	// 	}
	// 	$(".wrap-category--loader").fadeIn();
	// 	updateCartDebounce();
	// });



	var url = "";
	var orgSrc = "";
	// $("#filterForm").on("submit", function() {
	// 	url = $(this).serialize();
	// 	orgSrc = $(this).attr('action');
	// 	$.get(orgSrc, $(this).serializeArray())
	// 		.done(function(data) {
	// 			$(".wrap-category--items").html($(data).find(".wrap-category--items"));
	// 			history.pushState('', '', orgSrc + "?" + url);
	// 			$(".wrap-category--loader").fadeOut();
	// 			slider.slider('setAttribute', "min", $(data).find("#slider").data("slider-min"));
	// 			slider.slider('setAttribute', "max", $(data).find("#slider").data("slider-max"));
	// 			slider.slider('setAttribute', "value", $(data).find("#slider").data("slider-value"));
	// 			slider.slider('refresh');
	// 			$('.lazy').Lazy({
	// 				effect: "fadeIn",
	// 				effectTime: 1000,
	// 				threshold: 0
	// 			});
	// 			return false;
	// 		}, this);
	// 	return false;
	// });

	$('.btn-reset-selection').click(function() {
		$('.comparison-checkbox').prop('checked', false);
		$.get("index.php?dir=site&page=compare&op=reset");
	});

});
